<div class="edit-page">
  <div class="visitor">
    <button class="close" (click)="close()">
      <img class="cross-icon" src="icons/profile-close.svg" />
    </button>
    <span class="visitor-txt">Edit Name</span>
  </div>

  <p class="form-header">Enter the visitor's name</p>

  <input
    type="text"
    class="ac-input-control"
    placeholder="Enter name"
    [(ngModel)]="name"
    (keydown)="onTextInput($event)"
  />

  <div class="action-row">
    <button class="ac-secondary-btn" (click)="close()">Cancel</button>
    <button class="ac-primary-btn" (click)="continue()" [disabled]="!name.trim()">
      Update
    </button>
  </div>
</div>
